import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EventOrganizer = ({ organizer }) => {
  return (
    <div className="bg-[var(--color-card)] rounded-xl p-6 lg:p-8 space-y-6">
      <h2 className="text-2xl font-bold text-[var(--color-foreground)]">Event Organizer</h2>
      <div className="flex items-start gap-4">
        <div className="w-20 h-20 rounded-xl overflow-hidden flex-shrink-0">
          <Image 
            src={organizer?.logo} 
            alt={organizer?.logoAlt}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1">
          <h3 className="text-xl font-bold text-[var(--color-foreground)] mb-1">{organizer?.name}</h3>
          <p className="text-[var(--color-muted-foreground)] text-sm mb-3">{organizer?.tagline}</p>
          <div className="flex items-center gap-4 text-sm text-[var(--color-muted-foreground)]">
            <div className="flex items-center gap-1">
              <Icon name="MapPin" size={16} />
              <span>{organizer?.location}</span>
            </div>
            <div className="flex items-center gap-1">
              <Icon name="Users" size={16} />
              <span>{organizer?.volunteersServed}+ volunteers</span>
            </div>
          </div>
        </div>
      </div>
      <p className="text-[var(--color-muted-foreground)] leading-relaxed">
        {organizer?.description}
      </p>
      <div className="grid grid-cols-3 gap-4 py-4 border-y border-[var(--color-border)]">
        <div className="text-center">
          <p className="text-2xl font-bold text-[var(--color-primary)]">{organizer?.eventsHosted}</p>
          <p className="text-sm text-[var(--color-muted-foreground)]">Events Hosted</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-bold text-[var(--color-primary)]">{organizer?.impactScore}</p>
          <p className="text-sm text-[var(--color-muted-foreground)]">Impact Score</p>
        </div>
        <div className="text-center">
          <p className="text-2xl font-bold text-[var(--color-primary)]">{organizer?.rating}</p>
          <p className="text-sm text-[var(--color-muted-foreground)]">Rating</p>
        </div>
      </div>
      <div className="space-y-3">
        <Button 
          variant="outline" 
          fullWidth
          iconName="Building2"
          iconPosition="left"
        >
          View Organization Profile
        </Button>
        <Button 
          variant="ghost" 
          fullWidth
          iconName="Mail"
          iconPosition="left"
        >
          Contact Organizer
        </Button>
      </div>
    </div>
  );
};

export default EventOrganizer;